import { Dict } from '../../model/dict';
/**
 * Takes an array of dicts and creates a single dict where the individual dict values are added to an array.
 * If a dict lacks a value for a given id the resulting array for that value will be shorter.
 * @param dicts
 * @returns
 */
export function arrayOfDictsToDictOfArrays<T>(dicts: Array<Dict<T>>): Dict<Array<T>> {
  const dictOfArrays: Dict<Array<T>> = {};
  dicts.forEach((dict) => {
    Object.entries(dict).forEach(([id, value]) => {
      const list = dictOfArrays[id] ?? [];
      list.push(value);
      dictOfArrays[id] = list;
    });
  });
  return dictOfArrays;
}
